/*
  Papéo: kleine Helfer ohne Frameworks.
  - [data-pp-add="VARIANT_ID,VARIANT_ID"]: legt eine oder mehrere Varianten in den Warenkorb
    und öffnet den Dawn-Warenkorb-Drawer (Fallback: Warenkorb-Seite).
  - [data-pp-filter]: Filter-Chips für Produktlisten.
*/
(function () {
  const PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  async function addToCart(button) {
    const ids = button.dataset.ppAdd.split(',').map((id) => id.trim()).filter(Boolean);
    if (!ids.length || button.getAttribute('aria-busy') === 'true') return;

    const drawer = document.querySelector('cart-drawer');
    const body = { items: ids.map((id) => ({ id: Number(id), quantity: 1 })) };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Fehler');

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'papeo', productVariantId: ids[0], cartData: state });
      }

      if (button.classList.contains('pp-add')) {
        button.classList.add('is-added');
        button.innerHTML = CHECK;
        setTimeout(() => {
          button.classList.remove('is-added');
          button.innerHTML = PLUS;
        }, 1200);
      }

      if (drawer) {
        drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
        drawer.renderContents({ id: ids[0], sections: state.sections });
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      const msg = button.closest('[data-pp-scope]')?.querySelector('[data-pp-error]');
      if (msg) {
        msg.textContent = error.message;
        msg.hidden = false;
      }
      console.error(error);
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-pp-add]');
    if (add) {
      event.preventDefault();
      addToCart(add);
      return;
    }

    const chip = event.target.closest('[data-pp-chip]');
    if (chip) {
      const root = chip.closest('[data-pp-filter]');
      if (!root) return;
      root.querySelectorAll('[data-pp-chip]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      const key = chip.dataset.ppChip;
      root.querySelectorAll('[data-pp-tags]').forEach((card) => {
        card.hidden = !(key === 'all' || card.dataset.ppTags.split(' ').includes(key));
      });
    }
  });
})();
